import { computed, makeAutoObservable } from "mobx";

export enum ProgressIndicatorType {
  Any = "Any",
  ExcelExport = "ExcelExport",
  DesignAutomation = "DesignAutomation",
  ExcelImport = "ExcelImport",
  CloneScenario = "CloneScenario",
  CopyModelMaterials = "CopyModelMaterials",
  SyncApsUsers = "SyncApsUsers",
  DeleteProject = "DeleteProject",
  SplitModel = "SplitMOdel",
  CreateVersion = "CreateVersion",
  DeleteModel = "DeleteModel",
  UpdateVersion = "UpdateVersion",
}

export class ProgressIndicator {
  public progressIndicator: Map<ProgressIndicatorType, boolean> = new Map<ProgressIndicatorType, boolean>();

  constructor() {
    makeAutoObservable(
      this,
      {
        showProgressIndicator: computed,
      },
      {
        autoBind: true,
      },
    );
  }

  get showProgressIndicator(): boolean {
    return Array.from(this.progressIndicator.values()).some((v) => v);
  }

  getShowProgressIndicator = (progressIndicator: ProgressIndicatorType): boolean => {
    if (progressIndicator === ProgressIndicatorType.Any) {
      return Array.from(this.progressIndicator.values()).some((v) => v);
    }
    return this.progressIndicator.get(progressIndicator) || false;
  };

  setShowProgressIndicator = (progressIndicator: ProgressIndicatorType, show: boolean) => {
    this.progressIndicator.set(progressIndicator, show);
  };
}